import { render, staticRenderFns } from "./BaseBreadCrumbs.vue?vue&type=template&id=b099cc86&"
import script from "./BaseBreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./BaseBreadCrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
